var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.33398V13.6673C16 14.2173 16.45 14.6673 17 14.6673C17.55 14.6673 18 14.2173 18 13.6673V8.33398C18 7.78398 17.55 7.33398 17 7.33398C16.45 7.33398 16 7.78398 16 8.33398Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 4V13.6667C10.667 14.2167 11.117 14.6667 11.667 14.6667C12.217 14.6667 12.667 14.2167 12.667 13.6667V4C12.667 3.45 12.217 3 11.667 3C11.117 3 10.667 3.45 10.667 4Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 8.33398V13.6673C5.33301 14.2173 5.78301 14.6673 6.33301 14.6673C6.88301 14.6673 7.33301 14.2173 7.33301 13.6673V8.33398C7.33301 7.78398 6.88301 7.33398 6.33301 7.33398C5.78301 7.33398 5.33301 7.78398 5.33301 8.33398Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1V15.3333C0 17.9067 2.09333 20 4.66667 20H19.6667C20.2167 20 20.6667 19.55 20.6667 19C20.6667 18.45 20.2167 18 19.6667 18H4.66667C3.19667 18 2 16.8033 2 15.3333V1C2 0.45 1.55 0 1 0C0.45 0 0 0.45 0 1Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.733c03e195ec00e94e02503a7a4f43e5.svg";
export { ForwardRef as ReactComponent };